module.exports = __webpack_public_path__ + "static/media/ResumeOfMd_Asikur_Rahaman.caaf8ac8.pdf";